/**
 * Judge.me: přesměruje odkazy „Jak jsou recenze shromažďovány?"
 * (href → judge.me/authenticity) na vlastní stránku EcoHaus.
 * Recenze se načítají dynamicky (Judge.me je Vue app), proto MutationObserver —
 * přepisuje i odkazy, které se objeví/překreslí až po načtení stránky.
 */
(function () {
  var MATCH = 'judge.me/authenticity';
  var TARGET_URL = 'https://ecohaus.cz/pages/recenze-od-zakazniku';
  var SELECTOR = 'a[href*="' + MATCH + '"]';

  function fixLink(a) {
    if (!a || a.getAttribute('href') === TARGET_URL) return; // už přepsáno → nic (chrání před smyčkou)
    a.setAttribute('href', TARGET_URL);
    a.removeAttribute('target'); // interní odkaz — stejná záložka
    a.removeAttribute('rel');
    a.setAttribute('aria-label', 'Jak jsou recenze shromažďovány?');
  }

  function rewriteWithin(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTOR)) fixLink(node);
    if (node.querySelectorAll) {
      var links = node.querySelectorAll(SELECTOR);
      for (var i = 0; i < links.length; i++) fixLink(links[i]);
    }
  }

  function init() {
    rewriteWithin(document.body);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          // Pouze odkazy, které už na judge.me/authenticity odkazovaly (nebo stále odkazují) —
          // jinak by se sem zachytila libovolná jiná změna href v celém documentu (např. košík).
          if (m.target.matches && m.target.matches(SELECTOR)) fixLink(m.target);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          rewriteWithin(m.addedNodes[j]);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
